var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmacaoEntrega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0269 9.25684H11.418V18.764H21.0269V9.25684Z",
    fill: "#EC6262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8369 20.2119H13.0645V21.9307H19.8369V20.2119Z",
    fill: "#EC6262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 7.71594V5.85237C6.10938 4.93172 6.86353 4.18555 7.79404 4.18555H25.1285C26.059 4.18555 26.8131 4.93172 26.8131 5.85237V26.1512C26.8131 27.0719 26.059 27.818 25.1285 27.818H7.79404C6.86353 27.818 6.10938 27.0719 6.10938 26.1512V23.9238",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.9111H7.98842",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 9.79883V11.9111",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.6367H7.98842",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 14.5244V16.6367",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3623H7.98842",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 19.2539V21.3625",
    stroke: "#EC6262",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmacaoEntrega);
export default __webpack_public_path__ + "static/media/confirmacao-entrega.937ebae60615256fcade751ca334faf2.svg";
export { ForwardRef as ReactComponent };